import { IDefineCommand } from 'core-ts-types';
import { MajorProgram } from './../builders/major_programs_builder';

angular
  .module('major-explorer-data')
  .service('saveMajorCommand', ($http: ng.IHttpService, defineCommand: IDefineCommand, log: any) => {
    return defineCommand('saveMajorCommand', (deferred: ng.IDeferred<any>, major: MajorProgram) => {
      $http
        .post('favorite/favoriteitem/', { content_type: 'cat.program', object_id: major.id })
        .then(({ data }: { data: MajorProgram }) => {
          major.favorite_id = data.id;
          deferred.resolve(major);
        })
        .catch((error) => {
          log.issue('failed to save major');
          deferred.reject(error);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/commands/save_major_command.ts